import { MultipleBetType } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_10_Fold_Accumulator,
  TXTWCL_10_Folds,
  TXTWCL_11_Fold_Accumulator,
  TXTWCL_11_Folds,
  TXTWCL_12_Fold_Accumulator,
  TXTWCL_12_Folds,
  TXTWCL_13_Fold_Accumulator,
  TXTWCL_13_Folds,
  TXTWCL_14_Fold_Accumulator,
  TXTWCL_14_Folds,
  TXTWCL_15_Fold_Accumulator,
  TXTWCL_15_Folds,
  TXTWCL_16_Fold_Accumulator,
  TXTWCL_16_Folds,
  TXTWCL_17_Fold_Accumulator,
  TXTWCL_17_Folds,
  TXTWCL_18_Fold_Accumulator,
  TXTWCL_18_Folds,
  TXTWCL_19_Fold_Accumulator,
  TXTWCL_19_Folds,
  TXTWCL_20_Fold_Accumulator,
  TXTWCL_20_Folds,
  TXTWCL_21_Fold_Accumulator,
  TXTWCL_21_Folds,
  TXTWCL_22_Fold_Accumulator,
  TXTWCL_22_Folds,
  TXTWCL_23_Fold_Accumulator,
  TXTWCL_23_Folds,
  TXTWCL_24_Fold_Accumulator,
  TXTWCL_24_Folds,
  TXTWCL_25_Fold_Accumulator,
  TXTWCL_25_Folds,
  TXTWCL_4_Fold_Accumulator,
  TXTWCL_4_Folds,
  TXTWCL_5_Fold_Accumulator,
  TXTWCL_5_Folds,
  TXTWCL_6_Fold_Accumulator,
  TXTWCL_6_Folds,
  TXTWCL_7_Fold_Accumulator,
  TXTWCL_7_Folds,
  TXTWCL_8_Fold_Accumulator,
  TXTWCL_8_Folds,
  TXTWCL_9_Fold_Accumulator,
  TXTWCL_9_Folds,
  TXTWCL_Bet_Builder,
  TXTWCL_Canadian,
  TXTWCL_Double,
  TXTWCL_Doubles,
  TXTWCL_Goliath,
  TXTWCL_Heinz,
  TXTWCL_Lucky_15,
  TXTWCL_Lucky_31,
  TXTWCL_Lucky_63,
  TXTWCL_Patent,
  TXTWCL_Super_Heinz,
  TXTWCL_Treble,
  TXTWCL_Trebles,
  TXTWCL_Trixie,
  TXTWCL_Yankee
} from './getMultipleName.messages.json';

const multipleNames: Record<
  MultipleBetType,
  {
    straight: React.ComponentProps<typeof Translation>;
    multi: React.ComponentProps<typeof Translation>;
  }
> = {
  [MultipleBetType.DOUBLE]: {
    straight: TXTWCL_Double,
    multi: TXTWCL_Doubles
  },
  [MultipleBetType.TREBLE]: {
    straight: TXTWCL_Treble,
    multi: TXTWCL_Trebles
  },
  [MultipleBetType.FOURFOLD]: {
    straight: TXTWCL_4_Fold_Accumulator,
    multi: TXTWCL_4_Folds
  },
  [MultipleBetType.FIVEFOLD]: {
    straight: TXTWCL_5_Fold_Accumulator,
    multi: TXTWCL_5_Folds
  },
  [MultipleBetType.SIXFOLD]: {
    straight: TXTWCL_6_Fold_Accumulator,
    multi: TXTWCL_6_Folds
  },
  [MultipleBetType.SEVENFOLD]: {
    straight: TXTWCL_7_Fold_Accumulator,
    multi: TXTWCL_7_Folds
  },
  [MultipleBetType.EIGHTFOLD]: {
    straight: TXTWCL_8_Fold_Accumulator,
    multi: TXTWCL_8_Folds
  },
  [MultipleBetType.NINEFOLD]: {
    straight: TXTWCL_9_Fold_Accumulator,
    multi: TXTWCL_9_Folds
  },
  [MultipleBetType.TENFOLD]: {
    straight: TXTWCL_10_Fold_Accumulator,
    multi: TXTWCL_10_Folds
  },
  [MultipleBetType.ELEVENFOLD]: {
    straight: TXTWCL_11_Fold_Accumulator,
    multi: TXTWCL_11_Folds
  },
  [MultipleBetType.TWELVEFOLD]: {
    straight: TXTWCL_12_Fold_Accumulator,
    multi: TXTWCL_12_Folds
  },
  [MultipleBetType.THIRTEENFOLD]: {
    straight: TXTWCL_13_Fold_Accumulator,
    multi: TXTWCL_13_Folds
  },
  [MultipleBetType.FOURTEENFOLD]: {
    straight: TXTWCL_14_Fold_Accumulator,
    multi: TXTWCL_14_Folds
  },
  [MultipleBetType.FIFTEENFOLD]: {
    straight: TXTWCL_15_Fold_Accumulator,
    multi: TXTWCL_15_Folds
  },
  [MultipleBetType.SIXTEENFOLD]: {
    straight: TXTWCL_16_Fold_Accumulator,
    multi: TXTWCL_16_Folds
  },
  [MultipleBetType.SEVENTEENFOLD]: {
    straight: TXTWCL_17_Fold_Accumulator,
    multi: TXTWCL_17_Folds
  },
  [MultipleBetType.EIGHTEENFOLD]: {
    straight: TXTWCL_18_Fold_Accumulator,
    multi: TXTWCL_18_Folds
  },
  [MultipleBetType.NINETEENFOLD]: {
    straight: TXTWCL_19_Fold_Accumulator,
    multi: TXTWCL_19_Folds
  },
  [MultipleBetType.TWENTYFOLD]: {
    straight: TXTWCL_20_Fold_Accumulator,
    multi: TXTWCL_20_Folds
  },
  [MultipleBetType.TWENTYONEFOLD]: {
    straight: TXTWCL_21_Fold_Accumulator,
    multi: TXTWCL_21_Folds
  },
  [MultipleBetType.TWENTYTWOFOLD]: {
    straight: TXTWCL_22_Fold_Accumulator,
    multi: TXTWCL_22_Folds
  },
  [MultipleBetType.TWENTYTHREEFOLD]: {
    straight: TXTWCL_23_Fold_Accumulator,
    multi: TXTWCL_23_Folds
  },
  [MultipleBetType.TWENTYFOURFOLD]: {
    straight: TXTWCL_24_Fold_Accumulator,
    multi: TXTWCL_24_Folds
  },
  [MultipleBetType.TWENTYFIVEFOLD]: {
    straight: TXTWCL_25_Fold_Accumulator,
    multi: TXTWCL_25_Folds
  },
  [MultipleBetType.TRIXIE]: {
    straight: TXTWCL_Trixie,
    multi: TXTWCL_Trixie
  },
  [MultipleBetType.PATENT]: {
    straight: TXTWCL_Patent,
    multi: TXTWCL_Patent
  },
  [MultipleBetType.YANKEE]: {
    straight: TXTWCL_Yankee,
    multi: TXTWCL_Yankee
  },
  [MultipleBetType.CANADIAN]: {
    straight: TXTWCL_Canadian,
    multi: TXTWCL_Canadian
  },
  [MultipleBetType.HEINZ]: {
    straight: TXTWCL_Heinz,
    multi: TXTWCL_Heinz
  },
  [MultipleBetType.SUPER_HEINZ]: {
    straight: TXTWCL_Super_Heinz,
    multi: TXTWCL_Super_Heinz
  },
  [MultipleBetType.GOLIATH]: {
    straight: TXTWCL_Goliath,
    multi: TXTWCL_Goliath
  },
  [MultipleBetType.LUCKY15]: {
    straight: TXTWCL_Lucky_15,
    multi: TXTWCL_Lucky_15
  },
  [MultipleBetType.LUCKY31]: {
    straight: TXTWCL_Lucky_31,
    multi: TXTWCL_Lucky_31
  },
  [MultipleBetType.LUCKY63]: {
    straight: TXTWCL_Lucky_63,
    multi: TXTWCL_Lucky_63
  }
};

interface Multiple {
  numberOfLines: number;
  betType?: MultipleBetType;
  isEachWay?: boolean;
  isSgm?: boolean;
}

export const getMultipleName = ({ numberOfLines, betType, isEachWay, isSgm }: Multiple) => {
  if (isSgm) {
    return <Translation {...TXTWCL_Bet_Builder} />;
  }

  if (!betType) {
    return '';
  }

  const isStraightLineEachWay = numberOfLines === 2 && isEachWay;
  const version = isStraightLineEachWay || numberOfLines === 1 ? 'straight' : 'multi';
  const translationProps = multipleNames[betType][version];

  return <Translation {...translationProps} />;
};
